<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Set Home Address')"
          icon="mdi-home-map-marker"
          class="px-3 py-3 small-icon"
          color="primary"
        >
          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="3">
                  <z-country-select
                    class="purple-input"
                    v-model="address.country"
                  ></z-country-select>
                </v-col>

                <v-col cols="12" md="3">
                  <z-state-select
                    class="purple-input"
                    v-model="address.state"
                    :country="address.country"
                  ></z-state-select>
                </v-col>

                <v-col cols="12" md="3">
                  <z-city-select
                    class="purple-input"
                    v-model="address.city"
                    :state="address.state"
                    :country="address.country"
                  ></z-city-select>
                </v-col>
                <v-col>
                  <v-text-field
                    :label="$i18n.t('Pin Code')"
                    v-model="address.pinCode"
                  />
                </v-col>

                <v-col cols="12" md="12">
                  <v-text-field
                    :label="$i18n.t('Address')"
                    dense
                    v-model="address.addressLine"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <v-row>
                    <gmap-map
                      :center="center"
                      :zoom="12"
                      style="width:100%;  height: 450px;"
                      ref="mapRef"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        @click="center = m.position"
                      ></gmap-marker>
                    </gmap-map>
                    <div style="width:100%;position: absolute;">
                      <gmap-autocomplete
                        @place_changed="setPlace"
                        :label="$i18n.t('Seach Location')"
                      ></gmap-autocomplete>
                    </div>
                    <div
                      style="top:-275px; width:50px;position:relative; margin:auto"
                    >
                      <v-icon style="font-size: 50px;" color="red"
                        >mdi-map-marker</v-icon
                      >
                    </div>
                  </v-row>
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn
                    color="success"
                    class="mr-0"
                    @click="save()"
                    :loading="loading"
                  >
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  address = { country: "", state: "", city: "", addressLine: "" };
  url = "/api/profile/details";
  id = null;
  profile = {};
  center = { lat: 45.508, lng: -73.587 };
  markers = [];
  places = [];
  file = null;
  currentPlace = null;
  map = null;

  get loading() {
    return common.loading;
  }
  async mounted() {
    try {
      this.profile = await doGet(this.url);
      this.address = this.profile.address;
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
      });
      if (this.address.lat) {
        this.center = {
          lat: this.address.lat,
          lng: this.address.lon,
        };
      }
    } catch (e) {
      common.setError(e.message);
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
      });
    }
  }

  async save() {
    this.address.lat = this.map.getCenter().lat();
    this.address.lon = this.map.getCenter().lng();
    this.profile.address = this.address;
    // console.log(this.profile);
    try {
      common.setLoading(true);
      this.campus = await doPost("/api/profile/detail/save", this.profile);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }
  handleFileUpload(files) {
    if (files) {
      this.file = files[0];
    }
  }

  setPlace(place) {
    this.currentPlace = place;
    this.center = place.geometry.location;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
